import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const { user } = useContext(AuthContext);

  if (!user) return <Navigate to="/auth" />;

  // 🔥 ADD THIS CHECK
  if (!user.emailVerified) {
    return <Navigate to="/auth" />;
  }

  return children;
}